<template>
  <!--产线工时损耗-->
  <dv-border-box-13>
    <div class="item" :style="{ height: col + 'vh' }">
      <div class="font-weight font-s">{{ title }}</div>
      <div id="productLineEchart"></div>
      <canvas id="myCanvas" width="300" height="150" style="display: none">
        Your browser does not support the HTML5 canvas tag.
      </canvas>
    </div>
  </dv-border-box-13>
</template>

<script>
export default {
  name: "andon-productionline-loss",
  props: {
    col: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    hours: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headTitle: {
      type: String,
      default: function () {
        return "产线工时损耗";
      },
    },
  },
  data() {
    return {
      title: this.headTitle,
      bean: this.deviceBean,
      hourBean: this.hours,
      types: this.typeBean,
      startCharts: undefined,
      items: [],
      cookie: null,
    };
  },
  watch: {
    hours: {
      handler: function (val, oldVal) {
        this.hourBean = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("productLineEchart")
      );

      var data = this.hourBean;
      var xdata = [];
      var lineData = [];
      var lineData2 = [];
      var yMax1 = data[0].count;
      var yMax2 = data[0].hour;
      data.forEach((re) => {
        if (re["title"] != "其他") {
          if (re.count > yMax1) {
            yMax1 = re.count;
          }
          if (re.hour > yMax2) {
            yMax2 = re.hour;
          }
          xdata.push(re.title);
          lineData.push(re.count);
          var hour = (Number(re.hour) / (1000 * 60)).toFixed(2);
          lineData2.push(hour);
        }
      });
      console.log("打印", yMax1, yMax2);

      //自适应开始--------------------------------------
      var fontSize = 12;
      var symbolOffset = 12;
      var margin = 8;
      var yName = '损耗工时';
      var yNameGap = symbolOffset;
      var c=document.getElementById("myCanvas");
      var ctx=c.getContext("2d");
      ctx.font="12px none";
      var gridTop = symbolOffset + fontSize + 2;
      if(yName == null){
        gridTop = symbolOffset;
      }
      var gridLeft = 0;
      var gridBottom = fontSize + margin + 2;
      var gridRight = 0;
      var rotate = 0;

      var yLable1 = "";

      if(yMax1.toString().indexOf('.') != -1){
        yLable1 = yMax1.toString() + "0";
      }else{
        yLable1 = yMax1.toString() + ".0";
      }
      var yLable2 = ((yMax2/ (1000 * 60)).toFixed(2)).toString();
      if(yLable2.indexOf('.') != -1){
        yLable2 = yLable2 + "0";
      }else{
        yLable2 = yLable2 + ".0";
      }
      yLable2 = yLable2 + " m";
      gridLeft = ctx.measureText(yLable2).width + margin;
      gridRight = ctx.measureText(yLable1).width + margin;
      var gridWidth = (lineEchart.getWidth() - gridRight - gridLeft) / xdata.length;
      var lastWidth = 0;
      var xdataIndex = 0;
      var maxWidth = 0;
      xdata.forEach((text) => {
        var thisWidth = ctx.measureText(text).width;

        if(thisWidth > maxWidth){
          maxWidth = thisWidth;
        }
        if(lastWidth == 0){
          //第一个
          if((thisWidth / 2) > gridLeft){
            rotate = 45;
          }
        }

        if((thisWidth / 2 + lastWidth / 2) > gridWidth){
          rotate = 45;
        }

        if(xdataIndex == (xdata.length - 1)){
          //最后一个
          if((thisWidth / 2) > gridRight){
            rotate = 45;
          }
        }
        lastWidth = thisWidth;
        xdataIndex++;
      });

      if(rotate == 45){
        gridBottom = Math.sqrt(maxWidth * maxWidth / 2) + margin + fontSize / 2;

        if(gridBottom > lineEchart.getHeight() /  3 * 1){
          gridBottom = lineEchart.getHeight() /  3 * 1;
        }
      }
      //自适应结束--------------------------------------

      var option = {
        // backgroundColor:'#0f0',
        grid: {
          top: gridTop,
          left: gridLeft,
          right: gridRight,
          bottom: gridBottom,
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        // legend: {
        //   right: "15",
        //   data: ["损耗工时", "异常个数"],
        //   textStyle: {
        //     color: "#ffffff",
        //   },
        // },

        xAxis: {
          type: "category",
          boundaryGap: false,
          nameTextStyle: {
            color: "#ffffff",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontSize,
            },
            interval: 0,
            rotate: rotate,
          },
          data: xdata,
        },
        yAxis: [
          {
            type: "value",
            name: "损耗工时",
            nameGap: yNameGap,
            nameTextStyle:{
              color: "#fff",
              fontSize: fontSize,
              verticalAlign: 'bottom',
            },
            min: 0,
            max: (Number(yMax2) / (1000 * 60)).toFixed(2),
            splitNumber: 4,
            axisLabel: {
              formatter: "{value} m",
              margin: margin,
              textStyle: {
                color: "#fff",
                fontSize: fontSize,
              },
            },
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              symbolOffset: symbolOffset,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "异常个数",
            nameGap: yNameGap,
            nameTextStyle:{
              color: "#fff",
              fontSize: fontSize,
              verticalAlign: 'bottom',
            },
            min: 0,
            max: yMax1,
            splitNumber: 4,
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              symbolOffset: symbolOffset,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "异常个数",
            type: "line",
            yAxisIndex: 1,
            data: lineData,
          },
          {
            name: "损耗工时",
            type: "line",
            data: lineData2,
            itemStyle: {
              normal: {
                color: "#05D1FC", //折现点颜色
                lineStyle: {
                  color: "#05D1FC", //折现颜色
                },
              },
            },
          },
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      if (this.cookie) {
        clearInterval(this.cookie);
      }

      var index = 0; //显示tooltip,播放所在下标
      this.cookie = setInterval(function () {
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= xdata.length) {
          index = 0;
        }
      }, 2000);
    },
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.2rem 0.2rem;
  display: flex;
  flex-direction: column;
}
.item > div:nth-child(2){
  /*background-color: #FF0000;*/
  width: 100%;
  height: 100%;
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/andon/component/production-loss.vue